import isNumber from 'lodash/isNumber';
import isNaN from 'lodash/isNaN';
import isString from 'lodash/isString';

export const kebabCase = (source: string): string => {
  return source
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();
};

export const numberWithCommas = (n: number | string) => {
  if ((!isNumber(n) || !!isNaN(n)) && !isString(n)) {
    return;
  }
  const parts = n.toString().split('.');
  return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (parts[1] ? `.${parts[1]}` : '');
};

export const numberAsDollar = (n: string | number) => {
  if (n !== 0 && !n) {
    return '';
  }
  if ('number' === typeof n) {
    // if number is negative, make sure the negative sign is in front of dollar sign
    const negativeSign = n < 0 ? '-' : '';
    return `${negativeSign}$${numberWithCommas(Math.round(Math.abs(n) * 100) / 100)}`;
  }
  return n;
};

export const nameAndInitials = function (name: string | string[] | undefined) {
  if (!name || typeof name !== 'string') {
    return;
  }
  const names = name.split(' ');
  const firstName = names[0];
  const firstInitial = names[0].substring(0, 1).toUpperCase();

  let lastInitial;
  if (names.length > 1) {
    lastInitial = names[names.length - 1].substring(0, 1).toUpperCase();
  }
  return [firstInitial, lastInitial, firstName];
};
